import { Component } from '@angular/core';
import { isFormChange, onTypeChange } from 'app/core/shared/helper/equipment-registration.helper';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { Annulus } from 'app/modules/equipment-registration/model/annulus.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-annulus-b',
  templateUrl: './annulus-b.component.html',
  standalone: true,
  imports: [
    ...module,
    FormComponent
  ],
  styleUrls: ['./annulus-b.component.scss']
})
export class AnnulusBComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public annulusB: Annulus = new Annulus();
  public tempAnnulusB: Annulus = new Annulus();

  public isReplace: boolean = true;
  public disabledToggle: boolean = true;

  constructor(
    private equipmentServices: EquipRegistrationServices
  ) { }

  ngOnInit() {
    this.initializeAnnulusForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return '';

      if (wellEquipment?.annulusB) {
        this.annulusB = new Annulus(wellEquipment?.annulusB);
      } else {
        this.initializeAnnulusForm()
      }

      this.handleFormValue()
      this.annulusB.wellStringId = wellEquipment.wellStringId
      this.tempAnnulusB.wellStringId = wellEquipment.wellStringId
      this.isReplace = !wellEquipment?.annulusB;
      this.disabledToggle = !wellEquipment?.annulusB;
    })
  }

  private handleFormValue() {
    if (!this.annulusB.mdSceValveTypeId) {
      this.setSceValveTypeId()
    }

    this.tempAnnulusB = new Annulus(this.annulusB)
  }

  private initializeAnnulusForm(): void {
    this.annulusB.reset()
  }

  disabledSave(): boolean {
    return !this.annulusB.wellStringId && !this.annulusB.mdSceValveTypeId || isFormChange(this.annulusB, this.tempAnnulusB)
  }

  private setSceValveTypeId() {
    this.equipmentServices.getSceValveTypeId('ICV').subscribe(id => this.annulusB.mdSceValveTypeId = id)
  }

  save() {
    onTypeChange(this.annulusB)

    const operation = this.isReplace ?
      this.equipmentServices.addSceWellhead(this.annulusB) :
      this.equipmentServices.updateSceWellhead(this.annulusB);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.annulusB.wellStringId).subscribe();
      }
    });
  }
}
